module.exports = __webpack_public_path__ + "static/media/flyrest-5.965f723e.jpg";